export type IndianStateCode =
  | 'IN'
  | 'AN'
  | 'AP'
  | 'AR'
  | 'AS'
  | 'BR'
  | 'CH'
  | 'CG'
  | 'DH'
  | 'DL'
  | 'GA'
  | 'GJ'
  | 'HR'
  | 'HP'
  | 'JK'
  | 'JH'
  | 'KA'
  | 'KL'
  | 'LA'
  | 'LD'
  | 'MP'
  | 'MH'
  | 'MN'
  | 'ML'
  | 'MZ'
  | 'NL'
  | 'OD'
  | 'PY'
  | 'PB'
  | 'RJ'
  | 'SK'
  | 'TN'
  | 'TS'
  | 'TR'
  | 'UP'
  | 'UK'
  | 'WB'

export interface StateOption {
  code: IndianStateCode
  name: string
}

// English States
export const STATES_EN: StateOption[] = [
  { code: 'IN', name: 'India' },
  { code: 'AN', name: 'Andaman and Nicobar Islands' },
  { code: 'AP', name: 'Andhra Pradesh' },
  { code: 'AR', name: 'Arunachal Pradesh' },
  { code: 'AS', name: 'Assam' },
  { code: 'BR', name: 'Bihar' },
  { code: 'CH', name: 'Chandigarh' },
  { code: 'CG', name: 'Chhattisgarh' },
  { code: 'DH', name: 'Dadra and Nagar Haveli and Daman and Diu' },
  { code: 'DL', name: 'Delhi' },
  { code: 'GA', name: 'Goa' },
  { code: 'GJ', name: 'Gujarat' },
  { code: 'HR', name: 'Haryana' },
  { code: 'HP', name: 'Himachal Pradesh' },
  { code: 'JK', name: 'Jammu and Kashmir' },
  { code: 'JH', name: 'Jharkhand' },
  { code: 'KA', name: 'Karnataka' },
  { code: 'KL', name: 'Kerala' },
  { code: 'LA', name: 'Ladakh' },
  { code: 'LD', name: 'Lakshadweep' },
  { code: 'MP', name: 'Madhya Pradesh' },
  { code: 'MH', name: 'Maharashtra' },
  { code: 'MN', name: 'Manipur' },
  { code: 'ML', name: 'Meghalaya' },
  { code: 'MZ', name: 'Mizoram' },
  { code: 'NL', name: 'Nagaland' },
  { code: 'OD', name: 'Odisha' },
  { code: 'PY', name: 'Puducherry' },
  { code: 'PB', name: 'Punjab' },
  { code: 'RJ', name: 'Rajasthan' },
  { code: 'SK', name: 'Sikkim' },
  { code: 'TN', name: 'Tamil Nadu' },
  { code: 'TS', name: 'Telangana' },
  { code: 'TR', name: 'Tripura' },
  { code: 'UP', name: 'Uttar Pradesh' },
  { code: 'UK', name: 'Uttarakhand' },
  { code: 'WB', name: 'West Bengal' },
]

// Hindi States (हिन्दी)
export const STATES_HI: StateOption[] = [
  { code: 'IN', name: 'भारत' },
  { code: 'AN', name: 'अंडमान और निकोबार द्वीप समूह' },
  { code: 'AP', name: 'आंध्र प्रदेश' },
  { code: 'AR', name: 'अरुणाचल प्रदेश' },
  { code: 'AS', name: 'असम' },
  { code: 'BR', name: 'बिहार' },
  { code: 'CH', name: 'चंडीगढ़' },
  { code: 'CG', name: 'छत्तीसगढ़' },
  { code: 'DH', name: 'दादरा और नगर हवेली और दमन और दीव' },
  { code: 'DL', name: 'दिल्ली' },
  { code: 'GA', name: 'गोवा' },
  { code: 'GJ', name: 'गुजरात' },
  { code: 'HR', name: 'हरियाणा' },
  { code: 'HP', name: 'हिमाचल प्रदेश' },
  { code: 'JK', name: 'जम्मू और कश्मीर' },
  { code: 'JH', name: 'झारखंड' },
  { code: 'KA', name: 'कर्नाटक' },
  { code: 'KL', name: 'केरल' },
  { code: 'LA', name: 'लद्दाख' },
  { code: 'LD', name: 'लक्षद्वीप' },
  { code: 'MP', name: 'मध्य प्रदेश' },
  { code: 'MH', name: 'महाराष्ट्र' },
  { code: 'MN', name: 'मणिपुर' },
  { code: 'ML', name: 'मेघालय' },
  { code: 'MZ', name: 'मिजोरम' },
  { code: 'NL', name: 'नागालैंड' },
  { code: 'OD', name: 'ओडिशा' },
  { code: 'PY', name: 'पुडुचेरी' },
  { code: 'PB', name: 'पंजाब' },
  { code: 'RJ', name: 'राजस्थान' },
  { code: 'SK', name: 'सिक्किम' },
  { code: 'TN', name: 'तमिलनाडु' },
  { code: 'TS', name: 'तेलंगाना' },
  { code: 'TR', name: 'त्रिपुरा' },
  { code: 'UP', name: 'उत्तर प्रदेश' },
  { code: 'UK', name: 'उत्तराखंड' },
  { code: 'WB', name: 'पश्चिम बंगाल' },
]

// Kannada States (ಕನ್ನಡ)
export const STATES_KN: StateOption[] = [
  { code: 'IN', name: 'ಭಾರತ' },
  { code: 'AN', name: 'ಅಂಡಮಾನ್ ಮತ್ತು ನಿಕೋಬಾರ್ ದ್ವೀಪಗಳು' },
  { code: 'AP', name: 'ಆಂಧ್ರ ಪ್ರದೇಶ' },
  { code: 'AR', name: 'ಅರುಣಾಚಲ ಪ್ರದೇಶ' },
  { code: 'AS', name: 'ಅಸ್ಸಾಂ' },
  { code: 'BR', name: 'ಬಿಹಾರ್' },
  { code: 'CH', name: 'ಚಂಡೀಗಢ' },
  { code: 'CG', name: 'ಛತ್ತೀಸ್‌ಗಢ್' },
  { code: 'DH', name: 'ದಾದ್ರಾ ಮತ್ತು ನಗರ ಹವೇಲಿ ಮತ್ತು ದಮನ್ ಮತ್ತು ದಿಯು' },
  { code: 'DL', name: 'ದೆಹಲಿ' },
  { code: 'GA', name: 'ಗೋವಾ' },
  { code: 'GJ', name: 'ಗುಜರಾತ್' },
  { code: 'HR', name: 'ಹರಿಯಾಣ' },
  { code: 'HP', name: 'ಹಿಮಾಚಲ ಪ್ರದೇಶ' },
  { code: 'JK', name: 'ಜಮ್ಮು ಮತ್ತು ಕಾಶ್ಮೀರ' },
  { code: 'JH', name: 'ಝಾರ್ಖಂಡ್' },
  { code: 'KA', name: 'ಕರ್ನಾಟಕ' },
  { code: 'KL', name: 'ಕೇರಳ' },
  { code: 'LA', name: 'ಲಡಾಖ್' },
  { code: 'LD', name: 'ಲಕ್ಷದ್ವೀಪ' },
  { code: 'MP', name: 'ಮಧ್ಯ ಪ್ರದೇಶ' },
  { code: 'MH', name: 'ಮಹಾರಾಷ್ಟ್ರ' },
  { code: 'MN', name: 'ಮಣಿಪುರ್' },
  { code: 'ML', name: 'ಮೇಘಾಲಯ' },
  { code: 'MZ', name: 'ಮಿಜೋರಾಂ' },
  { code: 'NL', name: 'ನಾಗಾಲ್ಯಾಂಡ್' },
  { code: 'OD', name: 'ಒಡಿಶಾ' },
  { code: 'PY', name: 'ಪುದುಚೇರಿ' },
  { code: 'PB', name: 'ಪಂಜಾಬ್' },
  { code: 'RJ', name: 'ರಾಜಸ್ಥಾನ್' },
  { code: 'SK', name: 'ಸಿಕ್ಕಿಂ' },
  { code: 'TN', name: 'ತಮಿಳುನಾಡು' },
  { code: 'TS', name: 'ತೆಲಂಗಾಣ' },
  { code: 'TR', name: 'ತ್ರಿಪುರಾ' },
  { code: 'UP', name: 'ಉತ್ತರ ಪ್ರದೇಶ' },
  { code: 'UK', name: 'ಉತ್ತರಾಖಂಡ್' },
  { code: 'WB', name: 'ಪಶ್ಚಿಮ ಬಂಗಾಳ' },
]

// Tamil States (தமிழ்)
export const STATES_TA: StateOption[] = [
  { code: 'IN', name: 'இந்தியா' },
  { code: 'AN', name: 'அந்தமான் மற்றும் நிகோபார் தீவுகள்' },
  { code: 'AP', name: 'ஆந்திர பிரதேசம்' },
  { code: 'AR', name: 'அருணாசல பிரதேசம்' },
  { code: 'AS', name: 'அசாம்' },
  { code: 'BR', name: 'பீஹார்' },
  { code: 'CH', name: 'சண்டிகர்' },
  { code: 'CG', name: 'சத்தீஸ்கர்' },
  { code: 'DH', name: 'தாத்ரா மற்றும் நகர் ஹவேலி மற்றும் டாமன் மற்றும் டையூ' },
  { code: 'DL', name: 'தில்லி' },
  { code: 'GA', name: 'கோவா' },
  { code: 'GJ', name: 'குஜராத்' },
  { code: 'HR', name: 'ஹரியானா' },
  { code: 'HP', name: 'இமாசல பிரதேசம்' },
  { code: 'JK', name: 'ஜம்மு மற்றும் காஷ்மீர்' },
  { code: 'JH', name: 'ஜார்கண்ட்' },
  { code: 'KA', name: 'கர்நாடகா' },
  { code: 'KL', name: 'கேரளா' },
  { code: 'LA', name: 'லடாக்' },
  { code: 'LD', name: 'லட்சத்தீவுகள்' },
  { code: 'MP', name: 'மத்திய பிரதேசம்' },
  { code: 'MH', name: 'மஹாராஷ்டிரா' },
  { code: 'MN', name: 'மணிப்பூர்' },
  { code: 'ML', name: 'மேகாலயா' },
  { code: 'MZ', name: 'மிசோரம்' },
  { code: 'NL', name: 'நாகாலாந்து' },
  { code: 'OD', name: 'ஒடிசா' },
  { code: 'PY', name: 'புதுச்சேரி' },
  { code: 'PB', name: 'பஞ்சாப்' },
  { code: 'RJ', name: 'ராஜஸ்தான்' },
  { code: 'SK', name: 'சிக்கிம்' },
  { code: 'TN', name: 'தமிழ்நாடு' },
  { code: 'TS', name: 'தெலுங்கானா' },
  { code: 'TR', name: 'திரிபுரா' },
  { code: 'UP', name: 'உத்தர பிரதேசம்' },
  { code: 'UK', name: 'உத்தராகண்ட்' },
  { code: 'WB', name: 'மேற்கு வங்காளம்' },
]

// Telugu States (తెలుగు)
export const STATES_TE: StateOption[] = [
  { code: 'IN', name: 'భారతదేశం' },
  { code: 'AN', name: 'అండమాన్ మరియు నికోబార్ దీవులు' },
  { code: 'AP', name: 'ఆంధ్ర ప్రదేశ్' },
  { code: 'AR', name: 'అరుణాచల్ ప్రదేశ్' },
  { code: 'AS', name: 'అస్సాం' },
  { code: 'BR', name: 'బీహార్' },
  { code: 'CH', name: 'చండీగఢ్' },
  { code: 'CG', name: 'ఛత్తీస్‌గఢ్' },
  { code: 'DH', name: 'దాద్రా మరియు నగర్ హవేలీ మరియు డామన్ మరియు డయ్యూ' },
  { code: 'DL', name: 'ఢిల్లీ' },
  { code: 'GA', name: 'గోవా' },
  { code: 'GJ', name: 'గుజరాత్' },
  { code: 'HR', name: 'హర్యానా' },
  { code: 'HP', name: 'హిమాచల్ ప్రదేశ్' },
  { code: 'JK', name: 'జమ్మూ మరియు కాశ్మీర్' },
  { code: 'JH', name: 'జార్ఖండ్' },
  { code: 'KA', name: 'కర్ణాటక' },
  { code: 'KL', name: 'కేరళ' },
  { code: 'LA', name: 'లడఖ్' },
  { code: 'LD', name: 'లక్షద్వీప్' },
  { code: 'MP', name: 'మధ్య ప్రదేశ్' },
  { code: 'MH', name: 'మహారాష్ట్ర' },
  { code: 'MN', name: 'మణిపూర్' },
  { code: 'ML', name: 'మేఘాలయ' },
  { code: 'MZ', name: 'మిజోరం' },
  { code: 'NL', name: 'నాగాలాండ్' },
  { code: 'OD', name: 'ఒడిశా' },
  { code: 'PY', name: 'పుదుచ్చేరి' },
  { code: 'PB', name: 'పంజాబ్' },
  { code: 'RJ', name: 'రాజస్థాన్' },
  { code: 'SK', name: 'సిక్కిం' },
  { code: 'TN', name: 'తమిళనాడు' },
  { code: 'TS', name: 'తెలంగాణ' },
  { code: 'TR', name: 'త్రిపుర' },
  { code: 'UP', name: 'ఉత్తర ప్రదేశ్' },
  { code: 'UK', name: 'ఉత్తరాఖండ్' },
  { code: 'WB', name: 'పశ్చిమ బెంగాల్' },
]

export const getStatesByLanguage = (languageCode: string): StateOption[] => {
  switch (languageCode?.toLowerCase()) {
    case 'hi':
      return STATES_HI
    case 'kn':
      return STATES_KN
    case 'ta':
      return STATES_TA
    case 'te':
      return STATES_TE
    default:
      return STATES_EN
  }
}

export const INTERVAL_OPTIONS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Custom', value: 'custom' },
]

export const TEMPLE_CONFIG_FORM_INITIAL_VALUES = {
  multi_day: false,
  multi_temple: false,
  interval: 'daily',
  num_of_days: 1,
}

export const TEMPLE_CONFIG_VALIDATION_MESSAGES = {
  START_DATE_REQUIRED: 'Please select start date',
  INTERVAL_REQUIRED: 'Please select interval',
  NUM_OF_DAYS_REQUIRED: 'Please enter number of days',
  WEEKDAY_REQUIRED: 'Please select weekday',
  CUSTOM_DATES_REQUIRED: 'Please select dates',
  TEMPLE_REQUIRED: 'Please select at least one temple',
  FETCH_TEMPLES_ERROR: 'Failed to fetch temples',
}

export const TEMPLE_CONFIG_DRAWER_WIDTH = 720
export const TEMPLE_DEBOUNCE_DELAY = 800
